import { platformBrowser } from '@angular/platform-browser';
import { enableProdMode } from '@angular/core';
import { OktaConfigProvider } from '@app/okta-config-provider';
import { EnvironmentService } from 'pf-shared-lib-ui/coreLib';
import { provideHighcharts } from 'highcharts-angular';

async function appInit() {
    const appModuleContainer = await import('./app/app.module');
    platformBrowser()
        .bootstrapModule((appModuleContainer).AppModule, {
            applicationProviders: [
                provideHighcharts({
                    // 1. Sequentially load modules so dependencies evaluate in a strict linear order
                    instance: async () => {
                        // Step A: Load the base core constructor layout first
                        const { default: Highcharts } = await import('highcharts/esm/highcharts');

                        // Step B: Load the primary parent structural modules sequentially
                        await import('highcharts/esm/modules/stock');
                        await import('highcharts/esm/highcharts-more');
                        await import('highcharts/esm/modules/map');

                        // Step C: Load dependent extensions (now that their parent modules exist)
                        await import('highcharts/esm/modules/dumbbell');
                        await import('highcharts/esm/modules/marker-clusters');
                        await import('highcharts/esm/modules/accessibility');

                        // Step D: Return the fully composed core library instance to your Angular app
                        return Highcharts;
                    },

                    // 2. Keep this empty so the highcharts-angular wrapper doesn't fire parallel race-conditions
                    modules: () => []
                })
            ],
        })
        .then((ref) => {
            // Ensure Angular destroys itself on hot reloads.
            // tslint:disable: no-string-literal
            if ((window as any)['ngRef']) {
                (window as any)['ngRef'].destroy();
            }
            (window as any)['ngRef'] = ref;
        })
        .catch((err) => console.error(err));
}
fetch('config/config.json').then(res => res.json()).then(async (response) => {
    EnvironmentService.setConfig(response);
    OktaConfigProvider.setConfig(response.issuer, response.clientId);
    (window as any)['config'] = response;
    if (response.production) {
        enableProdMode();
        if (window && window.location.host !== 'localhost:4200') {
            window.console.log = window.console.warn = window.console.info = () => {
                // Don't log anything.
            };
        }
    }
}).finally(appInit);